import Header from './components/Header';
import Hero from './components/Hero';
import { AppSection, FAQSection, AboutSection, ContactSection, TopicsSection } from './components/SectionsA';
import { CarouselSection, MediaSection, RankingSection } from './components/SectionsB';
import { CardsSection, UpdatesSection, FeaturesSection } from './components/SectionsC';
import { CommentsSection, IndexSection } from './components/SectionsD';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />

        <AppSection />

        <FAQSection />

        <AboutSection />

        <ContactSection />

        <TopicsSection />

        <CarouselSection />

        <MediaSection />

        <RankingSection />

        <CardsSection />

        <UpdatesSection />

        <FeaturesSection />

        <CommentsSection />

        <IndexSection />
      </main>
      <Footer />
    </div>
  );
}